<template>
    <page :busy="busy">
        <b-alert variant="info" show>
            <p>Congratulations, your free Lodgix.com trial account has been established!</p>
            <p>
                A short "next steps" tour should be opening in a new window. Please take a few minutes to view the tour!
            </p>

            <p v-if="preload">
                <br />
                <button ng-disabled="preloadClicked" class="btn btn-primary" ng-click="preloadSampleData()">
                    Preload Sample Data</button
                ><br />
                <small>Note: You cannot preload sample data later.</small>
            </p>
        </b-alert>

        <div v-if="admin_app_preview" class="admin-app-section">
            <img class="admin-app-preview" :src="admin_app_preview" v-if="admin_app_preview" />
            <div class="info-section">
                <div>
                    <h2 style="font-weight: 900">DOWNLOAD</h2>
                    <h3 style="font-weight: 800">Lodgix Admin</h3>
                    <div style="display: flex; justify-content: center">
                        <p class="app-description">
                            Get the Lodgix Admin App for your phone or tablet to easily manage bookings, respond to
                            guests, and receive instant notifications on the go.
                        </p>
                    </div>
                </div>
                <div class="qr-code-links">
                    <div v-if="qr_code" v-html="qr_code" />
                    <div style="height: 165px !important; display: flex; align-items: center; justify-content: center">
                        <div style="display: flex; flex-direction: column; height: 150px !important">
                            <img class="store-badges" :src="google_play_store_badge" @click="openInNewTab(link || google_link)" />
                            <img class="store-badges" :src="apple_app_store_badge" @click="openInNewTab(link || apple_link)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <img src="https://ct.capterra.com/capterra_tracker.gif?vid=2077326&vkey=a13132b0875e54d863237ba898348d0a" />
    </page>
</template>

<script>
    import { mapState } from 'vuex';
    import isNil from 'lodash/isNil';
    import API from '../../../api';
    import page from '../../generic/page/page.vue';
    import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';
    import { SUBSCRIPTION_COMPLETED_DATA_ENDPOINT } from '../../../endpoints';

    export default {
        components: {
            page,
        },
        mixins: [removeScrollMixin],
        mounted() {
            this.loadScripts();
            this.fetchAdminApp();
            this.fetchCompletedData();
        },
        data() {
            return {
                busy: false,
                preload: false,
                qr_code: '',
                admin_app_preview: '',
                google_play_store_badge: '',
                apple_app_store_badge: '',
                link: '',
                apple_link: '',
                google_link: '',
            };
        },
        computed: {},
        methods: {
            isNil,
            async fetchCompletedData() {
                try {
                    this.busy = true;
                    const { data } = await API.get(SUBSCRIPTION_COMPLETED_DATA_ENDPOINT());
                    this.preload = data.preload;
                } catch (e) {
                    console.log(e);
                    this.errorToast({ text: 'Could not load subscription data.' });
                } finally {
                    this.busy = false;
                }
            },
            async fetchAdminApp() {
                try {
                    const response = await API.get(SUBSCRIPTION_COMPLETED_DATA_ENDPOINT() + 'admin-app/');
                    this.qr_code = response.data.qr_code;
                    this.admin_app_preview = response.data.admin_app_preview;
                    this.google_play_store_badge = response.data.google_play_store_badge;
                    this.apple_app_store_badge = response.data.apple_app_store_badge;
                    this.link = response.data.link;
                    this.apple_link = response.data.apple_app_store_link;
                    this.google_link = response.data.google_play_store_link;
                } catch (e) {
                    console.log(e);
                }
            },
            async loadScripts() {
                //let script = document.createElement('script');
                //script.src = '/static/pipeline/js/capterra.js';
                //script.async = true;
                //document.body.appendChild(script);
                let script = document.createElement('script');
                script.src = '/static/pipeline/js/ganalytics.js';
                script.async = true;
                document.body.appendChild(script);
            },
            openInNewTab(url) {
                window.open(url, '_blank', 'noopener,noreferrer');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .admin-app-section {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 0px 16px;
        height: 520px;
    }
    .admin-app-preview {
        height: 100%;
        width: auto;
        margin-right: -15px;
        z-index: 10 !important;
    }

    .qr-code-links {
        display: flex;
        justify-content: space-evenly;
    }

    .info-section {
        max-width: 620px;
        height: 80%;
        background: #0D47A1;
        padding: 15px 15px;
        color: white;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
    }

    .app-description {
        max-width: 70%;
    }

    .store-badges {
        height: 50%;
        width: 100%;
        padding: 5px;
        cursor: pointer;
        max-width: 220px;
    }

    @media (max-width: 768px) {
        .admin-app-preview {
            display: none;
        }
        .qr-code-links {
            flex-direction: column;
        }
        .info-section {
            height: 110%;
        }
        .admin-app-section {
            height: fit-content;
        }
        .app-description {
            max-width: 100%;
        }
    }
</style>
